// Based on iOS spec: https://quip-apple.com/zLPgAwegvdNt#temp:C:HFJb82a1012db3242a484dbaaed5
// There are some omissions here as I was not seeing the data come down from the API for web.
//
// For `cell` types, the title is expected to be a loc key.  If the data comes down from the
// API already translated, use `titleData` property with a value that is the object property.
export const infoGrouping = [
    {
        type: 'cell',
        title: 'ASE.Web.MusicClassical.TrackInfo.Heading.Composer',
        data: 'composerName',
        segue: 'composerAction',
    },
    {
        type: 'cell',
        title: 'ASE.Web.MusicClassical.TrackInfo.Heading.Work',
        data: 'workName',
        segue: 'workAction',
    },
    {
        type: 'cell',
        title: 'ASE.Web.MusicClassical.TrackInfo.Heading.CatalogNumber',
        data: 'workSubtitle',
    },
    {
        type: 'cell',
        title: 'ASE.Web.MusicClassical.TrackInfo.Heading.WorkNickname',
        data: 'workNickname',
    },
    {
        type: 'cell',
        titleData: 'movementHeading',
        data: 'movementName',
    },
    {
        type: 'grouping',
        data: 'artists',
    },
    {
        type: 'grouping',
        data: 'additionalArtists', // Do we get this?  Have seen additionalAuthors.
    },
    {
        type: 'cell',
        title: 'ASE.Web.MusicClassical.Album',
        data: 'albumName',
        segue: 'albumAction',
    },
];
